/* eslint-disable import/no-cycle */
import { all } from 'redux-saga/effects';

import auth from './modules/auth/sagas';

export default function* sagas() {
  return yield all([auth]);
}
